import { Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContexts';

export const PrivateRoute = ({ children }) => {
    const { currentUser } = useAuth();

    return ( currentUser ? children :  <Navigate to="/login"/>);
}